@if (cookies.consent() === null) {
  <div class="cookie-banner" role="dialog" aria-label="Aviso de cookies">
    <div class="cookie-banner__inner">
      <p class="cookie-banner__text">
        {{ t('cookie.message') }}
        <a routerLink="/privacidad" class="cookie-banner__link">{{ t('cookie.policy') }}</a>.
      </p>
      <div class="cookie-banner__actions">
        <button class="cookie-btn cookie-btn--ghost" (click)="reject()">
          {{ t('cookie.reject') }}
        </button>
        <button class="cookie-btn cookie-btn--primary" (click)="accept()">
          {{ t('cookie.accept') }}
        </button>
      </div>
    </div>
  </div>
}
